import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["submit"]

  submit() {
    if (!this.hasSubmitTarget) return

    const btn = this.submitTarget

    // Ocultar de forma permanente
    btn.hidden = true
    btn.disabled = true
    btn.setAttribute("aria-disabled", "true")
  }
}
